import { useState } from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

const ImageWithSkeleton = ({ src, alt, onLoaded, autoHeight, width, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <Box sx={{ position: 'relative', width: '100%', height: autoHeight ? 'auto' : '100%' }}>
      {!loaded && (
        <Skeleton
          variant="rectangular"
          animation={'wave'}
          sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        />
      )}
      <img
        src={src}
        alt={alt}
        onLoad={() => {
          setLoaded(true)
          if(onLoaded) onLoaded()
        }}
        style={{
          display: loaded ? 'block' : 'none',
          width: width || '100%',
          height: '100%',
          objectFit: 'cover',
          minHeight: '100%',
          maxHeight: '100%'
        }}
        {...rest}
      />
    </Box>
  );
};

export default ImageWithSkeleton;
